// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608311216/js/" + chunkId + "." + {"44":"b5c62cb7","225":"01ff9a93","481":"a9f05d3c","486":"2b938cac","770":"ebee4bc2"}[chunkId] + ".0.5392893417961833.chunk.js";
};